import { getLocale } from '../../../utils/pathHelper';
import * as moment from 'moment';

export function getLocaleDateFormat() {
  const locale = getLocale();
  const formats = {
    en : 'MM.DD.YYYY',
    ja : 'YYYY.MM.DD',
    'zh-TW' : 'YYYY.MM.DD',
    'zh-CN' : 'YYYY.MM.DD',
    'zh-HK' : 'DD.MM.YYYY',
  };   
  return formats[locale] || formats['en'];
}

export function setDatePickerLocale() {
  moment.locale(getLocale());
}

export function momentObjToFormattedString(momentObj): string {
  if (momentObj) {
    return momentObj.format('YYYY-MM-DD');
  }
  return ''
}

export function getCheckinDateMoment() {
  const twoMonthAfter = moment().add(60, 'days');
  const march4th = '2019-03-04';
  if (twoMonthAfter.isBefore(march4th)) {
    return moment(march4th);
  }
  return twoMonthAfter;
}

export function getCheckoutDateMoment() {
  const twoMonthAfterPlus1 = moment().add(61, 'days');
  const march5th = '2019-03-05';
  if (twoMonthAfterPlus1.isBefore(march5th)) {
    return moment(march5th)
  }
  return twoMonthAfterPlus1;
}